import { render, staticRenderFns } from "./ProductDetailPanel.vue?vue&type=template&id=61a45336&"
import script from "./ProductDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports